import { Colors, MaskedNumberInput } from '@gripp/shared-ui';
import { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { AlertInputs, ClearButtonProps } from './types';

export type BaseNumberInputProps = {
  alertInputName: AlertInputs;
  getValues: any;
  setValue: any;
  placeholder: string;
  inputLabelValue?: string;
  clearButton: (inputType: ClearButtonProps) => JSX.Element;
};

export const BaseNumberInputOld = ({
  alertInputName,
  getValues,
  setValue,
  placeholder,
  inputLabelValue,
  clearButton,
}: BaseNumberInputProps) => {
  const [localValue, setLocalValue] = useState(getValues(alertInputName));
  const [resetValues, setResetValues] = useState(getValues(alertInputName));

  const handleValueChange = (val: number | string) => {
    setLocalValue(val);
    setValue(alertInputName, `${val}`, {
      shouldDirty: true,
      shouldValidate: true,
    });
    if (!val) {
      setResetValues(new Date().getTime());
    }
  };

  return inputLabelValue ? (
    <View style={styles.inputContainer}>
      <MaskedNumberInput
        key={`${resetValues}`}
        value={localValue}
        decimalPlaces={0}
        onBlur={() => {}}
        onChangeText={handleValueChange}
        selectionColor={Colors.grayText}
        cursorColor={Colors.grayText}
        outlineStyle={{ borderWidth: 0 }}
        style={{
          flex: 1,
          backgroundColor: 'transparent',
          height: 40,
        }}
        hideClear
        placeholder={placeholder}
        label={inputLabelValue}
      />
    </View>
  ) : (
    <MaskedNumberInput
      key={`${resetValues}`}
      value={localValue}
      decimalPlaces={0}
      onBlur={() => {}}
      onChangeText={handleValueChange}
      selectionColor={Colors.grayText}
      cursorColor={Colors.grayText}
      outlineStyle={{ borderWidth: 0 }}
      style={{ flex: 1, backgroundColor: 'transparent', height: 50 }}
      hideClear
      placeholder={placeholder}
    />
  );
};

const styles = StyleSheet.create({
  inputContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'flex-start',
  },
  inputLabel: {
    fontSize: 11,
    fontWeight: '500',
    top: 5,
  },
  inputField: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    marginRight: 5,
    marginTop: 4,
    fontSize: 16,
    fontWeight: '400',
    borderWidth: 0,
    outlineWidth: 0,
    paddingVertical: 0,
    textAlignVertical: 'center',
    ...(Platform.OS === 'android' && {
      includeFontPadding: false,
    }),
  },
});
